import { useAppSelector } from "store/hooks";

const useIsInsertionModeEnabled = (): boolean => {
  const editorMode = useAppSelector(
    (state) => state.developer.edit.toolbar.editorMode
  );

  const isInsertionModeEnabled = editorMode.mode.includes("insert");

  return isInsertionModeEnabled;
};

export default useIsInsertionModeEnabled;
